import { graphql } from "../gql";

export const createAgentMessageRevisionMutationDoc = graphql(`
  mutation createAgentMessageRevision(
    $agentMessageId: UUID!
    $input: AgentMessageRevisionInput!
  ) {
    createAgentMessageRevision(agentMessageId: $agentMessageId, input: $input) {
      ...AgentMessageFragment
    }
  }
`);
